<script setup lang="ts">
import usePoolStore from '~/store/pool'
import { getSafeName } from '~/utils/format'
import IconLaunchGps from '~/components/Icons/IconLaunchGps.vue'

const { locale } = useI18n()
const poolStore = usePoolStore()

defineProps({
    isContainedInDrawer: { type: Boolean, default: true }
})

const onClickOnCityName = () => {
    if (window.location !== window?.parent?.location) {
        ;(window.top as Window).postMessage(
            {
                action: 'openUrl',
                url: `cities/${getSafeName(poolStore.getCity)}-${
                    poolStore.getCountryCode
                }`
            },
            document.referrer
        )
    } else {
        const newWnd = window.open(
            getChargemapUrl(
                `/cities/${getSafeName(poolStore.getCity)}-${poolStore.getCountryCode}`,
                locale.value
            ),
            '_top'
        )

        if (newWnd) {
            newWnd.opener = null
        }
    }
}

const onClickOnRoute = () => {
    if (poolStore.getDirectionLink) {
        const newWnd = window.open(poolStore.getDirectionLink, '_blank')

        if (newWnd) {
            newWnd.opener = null
        }
    }
}
</script>

<template>
    <div class="flex items-center" :class="{ 'mb-4': isContainedInDrawer }">
        <div v-if="isContainedInDrawer" class="text-gray-l-500 text-0.5sm">
            <p>{{ poolStore.getStreetNumber }} {{ poolStore.getStreetName }}</p>
            <p>
                {{ poolStore.getPostalCode }}
                <span
                    class="text-secondary-info cursor-pointer"
                    @click="onClickOnCityName"
                >
                    {{ poolStore.getCity }}
                </span>
            </p>
            <p>
                {{ poolStore.getCountryName }}
            </p>
        </div>
        <div v-else class="w-full text-gray-l-500 text-0.5sm">
            <div>
                <span>
                    {{ poolStore.getStreetNumber }}
                    {{ poolStore.getStreetName }}
                </span>
                <span>&nbsp;-&nbsp;</span>
                <span>
                    {{ poolStore.getPostalCode }}
                    <span
                        class="text-secondary-info cursor-pointer"
                        @click="onClickOnCityName"
                    >
                        {{ poolStore.getCity }}
                    </span>
                </span>
                <span>&nbsp;-&nbsp;</span>
                <span>
                    {{ poolStore.getCountryName }}
                </span>
            </div>
            <ChargemapB2CButton
                type="tertiary"
                size="large"
                class="ml-auto"
                @click="onClickOnRoute"
            >
                <template #icon>
                    <IconLaunchGps class="h-4" />
                </template>
                {{ $t('pool.display_route') }}
            </ChargemapB2CButton>
        </div>
    </div>
</template>
